<template>
  <v-list>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-list-item
        v-for="(action, index) in computedActions"
        :key="index"
        class="text-center action-list"
        style="cursor: pointer;"
        @click="getDocumentAISummary(action)"
      >
        <v-list-item-title>
          {{ action.actionName }}
        </v-list-item-title>
      </v-list-item>
    </v-form>
  </v-list>
</template>

<script>
var moment = require("moment");
import { useAuthStore } from "../../stores/auth";
import { useIndexStore } from "../../stores/index";
import { useAlertStore } from "../../stores/alert";

export default {
  name: "MeetingSummary",
  emits: ['get_ai_summary'],

  props: {
    meetingId: {
      type: String,
      default: "",
    },
    eventId: {
      type: String,
      default: "",
    },
    meeting: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    valid: false,
    reply: "",
    show: false,
    dialog_comment: false,
    current_comment: "",
    reply_comment: {},
    opened: [],
    rules: {
      passwordRules: [
        (v) => !!v || "Password is required",
        (v) => (v && v.length >= 3) || "Min 3 characters",
      ],
      selectRules: [(v) => !!v || "Select is required"],
      textRules: [
        v => !!v || 'Field is required',
        v => (v && v.length >= 3) || 'Min 3 characters',
      ],
      characterRules: [
        v => (v && v.length >= 3) || 'Min 3 characters',
      ],
    },
    token: localStorage.getItem("token") ? JSON.stringify(localStorage.getItem("token")).slice(1, -1) : "",
    auth: useAuthStore(),
    store: useIndexStore(),
    alert: useAlertStore(),
    actions: [
      { 
        actionId: 1, 
        actionName: "Meeting Summary" 
      },
      { 
        actionId: 2, 
        actionName: "Conference Summary" 
      },
    ],
  }),

  computed: {
    user() {
      return this.auth.getLoggedInUser;
    },
    dialog_rsvp() {
      return this.store.getDialogRSVP;
    },
    computedActions() {
      if ((this.meeting && this.meeting?.conferenceList && this.meeting?.conferenceList.length == 0) || !this.meeting?.conferenceList) {
        return this.actions.filter(action => action.actionId === 1);
      }

      return this.actions;
    },
  },
  
  methods: {
    formatDate(date) {
      return moment.unix(date).format("DD MMM YYYY");
    },

    formatDateAndTime(date) {
      return moment.unix(date).format("DD MMM YYYY, hh:mm A");
    },

    validate() {
      return this.$refs.form.validate();
    },

    resetForm() {
      return this.$refs.form.reset();
    },

    resetValidation() {
      return this.$refs.form.resetValidation();
    },

    reset() {
      this.reply = "";
      document.querySelector('html').classList.remove('v-overlay-scroll-blocked');
    },

    toggle(i) {
      const index = this.opened.indexOf(i);
      if (index > -1) {
        this.opened.splice(index, 1);
      } else {
        this.opened = [];
        this.opened.push(i);
      }
    },

    openReplyCommentDialog(comment) {
      this.dialog_comment = true;
      this.current_comment = comment['approverComment'];
      this.reply_comment = comment;
    },

    noRepliesFound() {
      this.alert.showInfo('No replies found');
    },

    getDocumentAISummary(action) {
      this.validate().then((validator_response) => {
        this.valid = validator_response.valid;
        if (this.valid) {
          this.$emit('get_ai_summary', action);
        }
      });
    },
  },
};
</script>

<style scoped>
.action-list:nth-child(odd) {
  background-color: rgba(86, 182, 229, .2);
}
.action-list:hover {
  background-color: rgba(255, 255, 255, 255) !important;
}
</style>